import axios from '@/utils/http';

export default () => {
  return axios
    .get('/user/my_advertisements')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
